// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"6cb986e8","299":"ac149403"}[chunkId] + ".chunk.css";
};